import React from "react";
import { Stack, Flex, Text, useColorModeValue, Code } from "@chakra-ui/react";
import { ContactForm } from "./ContactForm";

function Contact() {
  return (
    <Stack mt={40} mb={40} id="contact">
      <Flex
        flexDirection={["column", "column", "column"]}
        alignItems="center"
        w="100%"
      >
        <Text
          color={useColorModeValue("gray.800", "gray.200")}
          fontSize={28}
          mb={10}
        >
          Get In Touch
        </Text>
        <Text
          m={20}
          fontSize={20}
          color={useColorModeValue("gray.800", "gray.500")}
        >
          My inbox is always open, whether you have a question or just want to
          know me or even just to say hi , I'll try my best to get back to{" "}
          <Code colorScheme={"orange"}>you! 😊</Code>
        </Text>
        <ContactForm />
      </Flex>
    </Stack>
  );
}

export default Contact;
